import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearInterceptors, setupInterceptors } from 'services/auth';

export const useAxiosInterceptors = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const { reqId, resId } = setupInterceptors(navigate);
        return () => {
            clearInterceptors(reqId, resId);
        };
    }, [navigate]);
};
